import { dashboardExperienceResource } from './DashboardExperienceResource';
import { staticConfigResource } from './StaticConfigResource';

export const dashboardResources = [dashboardExperienceResource, staticConfigResource];
